import React from "react";
import { Link } from "react-router-dom";
import CatalogBotsContainer from "../../BotsContainer";

const CategoryView = (props) => {
	let { category, bots, userDomain } = props;
	let noOfBots = bots.length;
	let botsToShow = bots.slice(0, 2);
	
	if (noOfBots === 0) {
		return null;
	};

	return (
		<div className="card" style={{ borderRadius: "10px" }}>
			<div className="card-header">
				<h3
					className={`title mb-0 flex mr-auto order-0 ${userDomain}_font`}
					style={{
						color: "#4A4A4A",
						fontWeight: 600,
					}}
				>
					{category}
				</h3>
			</div>

			<div className="card-body" style={{ padding: "0rem" }}>
				<CatalogBotsContainer
					bots={botsToShow}
					botHolderStyle={{
						marginBottom: "10px",
						width: "100%",
						borderBottom: "1px solid #edf2f4",
						padding: "0rem 0.5rem",
					}}
				/>
				{noOfBots > 2 && (
					<div className={`flex justify-around items-start ${userDomain}_font`}>
						<Link
							style={{
								paddingTop: "0px",
								paddingBottom: "10px",
								color: "#638DFF",
							}}
							to={`/app/catalog/categories/${category}`}
						>
							Explore all
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default CategoryView;
